
  import { defineComponent, PropType } from 'vue';

  import { TTableColumnConfig } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TStorePaths } from '@/common/types/storePaths';

  import { TBaseViewsCountTableItem } from '@/modules/admin/types/statistics/common';

  import {
    STATISTICS_PORTAL_ACTIONS_NAME,
    STATISTICS_PORTAL_GETTERS_NAME,
    STATISTICS_PORTAL_MUTATIONS_NAME,
  } from '../../../store/statisticsPortal/name';
  import { TStatisticsPortalFilter } from '../../../types/statistics/statistics-portal';
  import StatisticsViewsCountByTimeTab from '../StatisticsViewsCountByTimeTab.vue';

  export default defineComponent({
    name: 'StatisticsPortalViewsCountByTimeTab',
    components: {
      StatisticsViewsCountByTimeTab,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
    data(): {
      tableStorePaths: TStorePaths;
      periodColumn: TTableColumnConfig<TBaseViewsCountTableItem>;
      chartStorePaths: TStorePaths;
    } {
      return {
        tableStorePaths: {
          action: STATISTICS_PORTAL_ACTIONS_NAME.getViewsCountByTimeTable,
          mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setViewsCountByTimeTable,
          getter: STATISTICS_PORTAL_GETTERS_NAME.getViewsCountByTimeTable,
        },
        periodColumn: {
          field: 'name',
          title: 'Период/Группа пользователей',
        },
        chartStorePaths: {
          action: STATISTICS_PORTAL_ACTIONS_NAME.getViewsCountByTimeChartData,
          mutation: STATISTICS_PORTAL_MUTATIONS_NAME.setViewsCountByTimeChartData,
          getter: STATISTICS_PORTAL_GETTERS_NAME.getViewsCountByTimeChartData,
        },
      };
    },
  });
